{
  "orderDetail": {
    "header": {
      "back": "Order",
      "order": "Order",
      "orderUID": "Order UID:",
      "productType": "Product Type:",
      "loanId": "Loan ID:",
      "status": "Status"
    },
    "orderInfo": {
      "title": "Order Info",
      "summary": {
        "client": "Client:",
        "vendor": "Vendor:",
        "creationDate": "Creation:",
        "clientSla": "Client SLA:",
        "closeDate": "Close:"
      },
      "general": {
        "title": "General"
      },
      "client": {
        "title": "Client Information"
      },
      "vendor": {
        "title": "Vendor Details"
      },
      "lastUpdate": "Last update:",
      "actions": {
        "addDeadline": "Add Deadline",
        "cancelOrder": "Cancel Order"
      }
    },
    "loanDetails": {
      "title": "Loan Details",
      "summary": {
        "loanNumber": "Loan #: ",
        "borrowerName": "Borrower: "
      },
      "general": {
        "title": "General Loan Details"
      },
      "property": {
        "title": "Property Details"
      },
      "borrower": {
        "title": "Borrower Details"
      }
    },
    "invoicingDetails": {
      "title": "Invoicing Details",
      "search": "Search",
      "uploadDocument": "Upload Document",
      "createInvoice": "Create Invoice",
      "columns": {
        "date": "Date",
        "amount": "Amount",
        "payee": "Payee",
        "invoiceNumber": "Invoice #",
        "datePaid": "Date Paid",
        "dueDate": "Due Date",
        "checkNumber": "Check #",
        "actions": "Actions"
      },
      "emptyState": {
        "title": "No invoices found.",
        "messageWithSearch": "Try adjusting your search criteria.",
        "messageNoSearch": "There are no invoices to display at this time."
      },
      "actions": {
        "openFile": "Open File",
        "downloadFile": "Download File"
      },
      "errors": {
        "downloadFailed": "Failed to download document. Please try again."
      }
    },
    "tabs": {
      "details": "Details",
      "lifecycle": "Lifecycle",
      "documents": "Documents",
      "tasks": "Tasks"
    },
    "top": {
      "loanId": "Loan ID:",
      "status": "Status:",
      "clientDue": "Client Due:",
      "vendorDue": "Vendor Due:"
    },
    "footer": {
      "lastUpdate": "Last update:",
      "addDeadline": "Add Deadline",
      "cancelOrder": "Cancel Order"
    },
    "actions": {
      "reproject": {
        "label": "Reproject",
        "tooltip": "Recalculate order timeline and projections",
        "success": "Order reprojected successfully",
        "error": "Failed to reproject order",
        "processing": "Reprojecting..."
      }
    },
    "documents": {
      "search": "Search documents",
      "toggleFilters": "Filter",
      "clearFilters": "Clear Filters",
      "filters": {
        "type": "Document Type",
        "source": "Source",
        "uploadedBy": "Uploaded By"
      },
      "columns": {
        "fileName": "File Name",
        "documentId": "Document #",
        "type": "Type",
        "source": "Source",
        "uploadedBy": "Uploaded By",
        "uploadedAt": "Uploaded At",
        "lastModified": "Last Modified"
      }
    }
  }
}
